import { FC, useMemo } from "react";

import { ArrowUpOutlined } from "@ant-design/icons"
import { Flex, Statistic, Typography } from "antd"

import { BarChart } from "../../../../../../../../../shared/components/Charts";
import { Card } from "@hdi-seguros/web-components.card";
import { ColSize, RowSize } from "../../../../../../../../../shared/components";

import { GetQuotationGraphicInfoServiceResponse } from "../../../../../../../../../shared/interfaces";

import { formattedPrice } from "../../../../../../../../../shared/utils";

import './index.css';
interface QuotationInfoProps {
    quotationGraphicInfo?: GetQuotationGraphicInfoServiceResponse;
}

export const QuotationInfo: FC<QuotationInfoProps> = ({ quotationGraphicInfo }) => {

    const data = useMemo(
        () => quotationGraphicInfo?.emitidasPorDia.map(
            ({ dia, cantidad }) => ({
                day: dia,
                value: cantidad, 
            })
        ) ?? [], 
        [quotationGraphicInfo]
    )

    return (
        <Flex vertical>
            <ColSize size={80}>
                <Card className="quotation-info-card">
                    <ColSize size={100} colProps={{ className: 'quotation-info-container-card' }} >
                        <Card className="quotation-info-specific-info-card" >
                            <RowSize>
                                <ColSize
                                    size={25}
                                >
                                    <RowSize>
                                        <Typography.Title level={4} className="quotation-info-specific-info-titles" > Pólizas Vigentes </Typography.Title>
                                    </RowSize>
                                    <RowSize rowProps={{ style: { columnGap: 8 }, align: 'middle' }}  >
                                        <Typography.Title level={ 3 } className="quotation-info-specific-info-main-values" > { quotationGraphicInfo?.polizasVigentes } </Typography.Title>
                                        <Statistic 
                                            value={ quotationGraphicInfo?.variacionPolVigentes }
                                            valueStyle={{ color: '#3f8600', fontSize: 12 }}
                                            prefix={<ArrowUpOutlined />}
                                            suffix="%"
                                            precision={0}
                                        />
                                        <Typography.Text type="secondary"> mes anterior </Typography.Text>
                                    </RowSize>
                                </ColSize>

                                <ColSize
                                    size={25}
                                >
                                    <RowSize>
                                        <Typography.Title level={4} className="quotation-info-specific-info-titles"> Representan </Typography.Title>
                                    </RowSize>
                                    <RowSize  rowProps={{ style: { columnGap: 6 }, align: 'bottom' }} >
                                        <Typography.Title level={ 4 } className="quotation-info-specific-info-main-values">{ formattedPrice(quotationGraphicInfo?.porcentajeCartera) }%</Typography.Title>
                                        <Typography.Text type="secondary"> de la cartera </Typography.Text>
                                    </RowSize>
                                </ColSize>

                                <ColSize
                                    size={25}
                                >
                                    <RowSize>
                                        <Typography.Title level={4}  className="quotation-info-specific-info-titles"> Emitidas </Typography.Title>
                                    </RowSize>
                                    <RowSize rowProps={{ style: { columnGap: 6 }, align: 'bottom' }} >
                                        <Typography.Title level={ 4 } className="quotation-info-specific-info-main-values"> { quotationGraphicInfo?.cantEmitidasMes } </Typography.Title>
                                        <Typography.Text type="secondary"> en el mes </Typography.Text>
                                    </RowSize>
                                </ColSize>
                            </RowSize>
                        </Card>
                    </ColSize>

                    <BarChart 
                        data={data} 
                        title="Últimos 7 días"
                        subTitle="Gráfico pólizas emitidas en la última semana"
                        xDataKey="day"
                        barProps={{ dataKey: 'value' }}
                        legendProps={{ label: "Cantidad de pólizas emitidas por día" }}
                    />
                </Card>
            </ColSize>
            
        </Flex>
    )
}
